<div class="montador">
  <div class="montador-topo">
    <span class="montador-titulo">Montador de E-mail</span>
    <button type="button" class="montador-fechar" (click)="cancelar()" matTooltip="Fechar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="montador-corpo">
    <aside class="paleta">
      <span class="paleta-titulo">ELEMENTOS</span>
      @for (item of paleta; track item.tipo) {
        <button type="button" class="paleta-item" [disabled]="itemDesabilitado(item)"
                (click)="adicionarBloco(item.tipo)">
          <mat-icon>{{ item.icone }}</mat-icon>
          <span>{{ item.rotulo }}</span>
        </button>
      }
      <span class="paleta-dica">Clique para adicionar. Use as setas de cada bloco para reordenar.</span>
    </aside>

    <section class="editor">
      <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -- rótulo do input interno do app-form-field abaixo, que o linter não enxerga -->
      <label class="editor-label">Assunto do e-mail</label>
      <app-form-field
        class="campo-assunto-email"
        placeholder="Assunto do e-mail"
        heightFormField="42px"
        [value]="modelo.assunto"
        [disabled]="somenteLeitura"
        (changeValue)="atualizarAssunto($event)">
      </app-form-field>

      <div class="lista-blocos" cdkDropList (cdkDropListDropped)="onReordenarBlocos($event)">
        @for (bloco of modelo.blocos; track bloco.id; let i = $index) {
          <div class="bloco-item" cdkDrag [cdkDragDisabled]="somenteLeitura">
            <div class="bloco-item-handle" cdkDragHandle matTooltip="Arraste para reordenar">
              <mat-icon>drag_indicator</mat-icon>
            </div>
            <app-bloco-email-editor
              class="bloco-item-conteudo"
              [bloco]="bloco"
              [primeiro]="i === 0"
              [ultimo]="i === modelo.blocos.length - 1"
              [disabled]="somenteLeitura"
              [variaveis]="variaveis"
              (mudou)="aoAlterarBloco(bloco)" (subir)="subir(i)" (descer)="descer(i)"
              (moverTopo)="moverTopo(i)" (moverFundo)="moverFundo(i)" (excluir)="removerBloco(i)">
            </app-bloco-email-editor>
            <div class="bloco-item-placeholder" *cdkDragPlaceholder></div>
          </div>
        } @empty {
          <div class="editor-vazio">Adicione elementos pela lista ao lado para montar o e-mail.</div>
        }
      </div>
    </section>

    <aside class="preview">
      <div class="preview-cabecalho">
        <span class="preview-dot"></span>
        <span>Preview</span>
      </div>

      <div class="preview-conteudo">
        <span class="preview-assunto-label">ASSUNTO</span>
        <span class="preview-assunto-valor">{{ assuntoPreview || '—' }}</span>
        <div class="preview-frame-wrap">
          <app-email-preview [html]="htmlPreview" [blocoAlvoId]="blocoPreviewId"></app-email-preview>
        </div>
        @if (variaveis.length) {
          <span class="preview-nota">*Variáveis exibidas com dados do primeiro contato.</span>
        }
      </div>

      @if (!somenteLeitura) {
        <div class="preview-acoes">
          <app-button-padrao
            label="Voltar"
            width="100%"
            height="42px"
            backgroundColor="white"
            color="var(--vermelho-padrao)"
            borderColor="var(--vermelho-padrao)"
            borderStyle="solid"
            borderWidth="1px"
            borderRadius="8px"
            (buttonClick)="cancelar()">
          </app-button-padrao>
          <app-button-padrao
            label="Salvar"
            width="100%"
            height="42px"
            backgroundColor="var(--verde-padrao)"
            color="white"
            borderRadius="8px"
            (buttonClick)="salvar()">
          </app-button-padrao>
        </div>
      }
    </aside>
  </div>
</div>
